const SIGNAL_STORAGE_KEY = "axon-onboarding-signal-v1";

function reducedMotion() {
  return globalThis.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches === true;
}

export function playOnboardingSignal() {
  if (reducedMotion()) return;
  try {
    if (globalThis.sessionStorage?.getItem(SIGNAL_STORAGE_KEY)) return;
    globalThis.sessionStorage?.setItem(SIGNAL_STORAGE_KEY, "played");
  } catch {
    // Сигнал не должен влиять на рабочий сценарий в приватном режиме.
  }

  try {
    globalThis.navigator?.vibrate?.(18);
  } catch {
    // Вибрация опциональна и зависит от устройства.
  }

  try {
    const AudioContext = globalThis.AudioContext || globalThis.webkitAudioContext;
    if (!AudioContext) return;
    const context = new AudioContext();
    const gain = context.createGain();
    gain.gain.setValueAtTime(0.0001, context.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.035, context.currentTime + 0.018);
    gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.28);
    gain.connect(context.destination);

    [523.25, 659.25].forEach((frequency, index) => {
      const oscillator = context.createOscillator();
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(frequency, context.currentTime);
      oscillator.connect(gain);
      oscillator.start(context.currentTime + index * 0.07);
      oscillator.stop(context.currentTime + 0.2 + index * 0.07);
    });
    globalThis.setTimeout?.(() => void context.close().catch(() => undefined), 420);
  } catch {
    // Блокировка аудио браузером оставляет визуальный сигнал полноценным.
  }
}
